(function() {
    'use strict';
    angular.module('reviseorder', [ 'ngSanitize', 'mnp.config'
    ]);
})();
